import styled from 'styled-components';
import { black } from 'styles/Colors';

export const ForbiddenPage = styled.div`
  height: calc(100vh - 106px);
`;
export const TextContainer = styled.div`
  position: absolute;
  transform: translate(0%, -50%);
  top: 50%;
  left: 20%;
  z-index: 1;
`;
export const Header = styled.p`
  font-family: Oswald;
  font-size: 42px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: 1.14px;
  text-transform: uppercase;
  color: ${black};
  margin: 0;
`;
export const Subtext = styled.p`
  font-family: Lato;
  font-size: 22.5px;
  color: ${black};
`;
export const ImageContainer = styled.div`
  position: absolute;
  transform: translate(0%, -50%);
  top: 50%;
  right: 20%;

  img {
    width: 750px;
    height: auto;
  }
`;
